module.exports = __webpack_public_path__ + "img/17.708b6a96.gif";